export default __webpack_public_path__ + "static/media/six.55c0966e.svg";